module.exports = __webpack_public_path__ + "static/ablemployment-logo-eedfd163e363c0bd58b573ca9f9e2375.png";